import { render, staticRenderFns } from "./SubscriptionRecord.vue?vue&type=template&id=b06bc600&scoped=true"
import script from "./SubscriptionRecord.vue?vue&type=script&lang=js"
export * from "./SubscriptionRecord.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionRecord.vue?vue&type=style&index=0&id=b06bc600&prod&lang=scss"
import style1 from "./SubscriptionRecord.vue?vue&type=style&index=1&id=b06bc600&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06bc600",
  null
  
)

export default component.exports